import React from "react";

export default function Privacy() {
  return (
    <main style={{ padding: "20px", lineHeight: 1.6 }}>
      <h1>Privacy Policy</h1>

      <p>
        Skybridge Flights respects your privacy and is committed to protecting it.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We do not collect personal data unless you provide it voluntarily.
      </p>

      <h2>How We Use Information</h2>
      <p>
        Any provided information is used only to improve user experience.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        The app may use services like Google which may collect limited data.
      </p>

      <h2>Contact</h2>
      <p>Email: your@email.com</p>
    </main>
  );
}